import React, { useContext, useEffect, useMemo, useState, useRef, useCallback } from 'react';
import { tabulatorGet, downloadBlobGet, fetchTextGet } from '../../api/ApiController';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { ReactTabulator, reactFormatter } from 'react-tabulator';
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css';
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { Avatar } from 'primereact/avatar';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { MdSearch } from "react-icons/md";
import { MdSearchOff } from "react-icons/md";
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, PrintIcon, SearchIcon, ExportIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, EditRowIcon } from "../svg/svgIcons";
import { DateTime } from "luxon";
import AuthContext from '../../components/AuthContext';
import UtilContext from '../../components/UtilContext';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import { showDeactivatedInLists, showInactiveEmployeesInLists } from '../../utils/moduleSettings';
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../utils/tabulatorScroll';
import { resetTabulatorMask } from '../../utils/tabulatorResetMask';
import { primeMultiSelectHeaderFilter } from '../../utils/primeMultiSelectHeaderFilter';
import { LocaleContext } from '../../components/LocaleContext';
import { getEffectiveMask } from '../../utils/effectiveMask';
import { cleanSorters, coerceHeaderFilterList, extractSafePaginationParams, createDedupedAjaxRequest, safeParse, parseSorters, parseMaskFilters, mergePagedStandardListFiltersAndSorters, sanitizeTabulatorLayoutAttributes, TABULATOR_GROUP_A_FLAT_REMOTE_LAYOUT_SANITIZE_OPTIONS } from '../../utils/tabulatorProgressiveLoading';
import { dateUserHeaderFilter } from '../../utils/dateUserHeaderFilter';
import { inputOnEnterHeaderFilter } from '../../utils/inputOnEnterHeaderFilter';
import { tabulatorColumnMinWidthFromTitle, tabulatorDateUserColumnMinWidth } from '../../utils/tabulatorColumnMinWidth';
import { buildTabulatorIdColumn } from '../../utils/tabulatorIdColumn';
import { TABULATOR_AUDIT_MIN_ROW_HEIGHT } from '../../utils/tabulatorAuditColumns';
import {
  TRAINING_CARDS_REMOVED_EVENT,
  TRAINING_CARDS_UPDATED_EVENT,
  SESSION_SAFE_UPDATE,
  applyPagedMutationOverlay,
  classifyTrainingCardListMutation,
} from '../../utils/trainingCardListSync';
import { buildExportQueryStringFromParams, openPrintHtmlWindow, triggerBlobDownload } from '../../utils/serviceTaskExport';
import { xlsxDownloadFilename } from '../../utils/exportExcelNaming';
import PrintOptionsDialog from '../../components/PrintOptionsDialog';
import { applyTabulatorRuntimeI18n } from '../../utils/tabulatorRuntimeI18n';
const TRAINING_CARD_LIST_COLUMN_I18N_KEYS = Object.freeze({
  'name': 'EmployeeAdd.Label.Name',
  'defined_id': 'Common.DefinedId',
  'department.name': 'Common.Department',
  'my_state': 'Common.Status',
  'my_status': 'Common.EmployeeStatus',
  'date_of_entry': 'EmployeeAdd.Label.DateOfEntry',
  'date_of_departure': 'EmployeeAdd.Label.DateOfDeparture',
  'description': 'EmployeeAdd.Label.Description',
  'rowSelection': 'EmployeeAdd.Label.Name',
});



const PAGE_LIST_KEY = 'TrainingCardList';

const DEFAULT_COLUMNS_VISIBLE = Object.freeze({
  id: true,
  name: true,
  defined_id: true,
  'department.name': true,
  my_state: true,
  my_status: true,
  date_of_entry: true,
  date_of_departure: true,
  description: true,
  created_at: true,
  updated_at: true,
});

function mergeVisibility(saved) {
  const merged = { ...DEFAULT_COLUMNS_VISIBLE };
  if (saved && typeof saved === 'object') {
    Object.keys(DEFAULT_COLUMNS_VISIBLE).forEach((k) => {
      if (Object.prototype.hasOwnProperty.call(saved, k)) merged[k] = saved[k] !== false;
    });
  }
  if (!Object.values(merged).some(Boolean)) return { ...DEFAULT_COLUMNS_VISIBLE };
  return merged;
}

function applyDataColumnVisibilityToTable(table, visibilityMap) {
  if (!table) return;
  for (const f of Object.keys(DEFAULT_COLUMNS_VISIBLE)) {
    if (visibilityMap[f] === false) table.hideColumn?.(f);
    else table.showColumn?.(f);
  }
  setTimeout(() => table.redraw?.(true), 0);
}

function layoutAttributesIncludeId(attributes) {
  if (!Array.isArray(attributes)) return false;
  return attributes.some((node) => node && typeof node === 'object' && node.field === 'id');
}

export default function TrainingCardList(){

  const [state, dispatch] = useContext(DatabaseContext);
  const { user } = useContext(AuthContext);
  const { t, locale } = useContext(LocaleContext);
  const { setUserMaskFilter, openFavoriteDialog, toast, setFastView, getDateFormat, formatDate, getUserColor, getUserInitials, openChosenNotificationPreferences, setDialogText, setVisible } = useContext(UtilContext);
  const dateFmt = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
  const dateTimeFmt = `${dateFmt} HH:mm`;

  const pageSizePc = useMemo(() => {
    const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
    const n = parseInt(v, 10);
    return (Number.isFinite(n) && n > 0) ? n : 50;
  }, [state.module_settings]);

  const showDeactivated = showDeactivatedInLists(state.module_settings, 'training');
  const showInactiveEmployees = showInactiveEmployeesInLists(state.module_settings);

    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [favoriteIcon,setFavoriteIcon] = useState(false);
    const [copyIcon,setCopyIcon] = useState(true);
    const [insertIcon,setInsertIcon] = useState(!user.permissions?.includes("add training"));

    const [visibleSearch,setVisibleSearch] = useState(false);
    const [searchIconColor,setSearchIconColor] = useState("");
    const [searchValue,setSearchValue] = useState('');

    const [markUnmark, setMarkUnmarked] = useState(true);

    const [columnsVisible, setColumnsVisible] = useState({ ...DEFAULT_COLUMNS_VISIBLE });
    const [maskVisible, setMaskVisible] = useState(false);
    const [printChoiceVisible, setPrintChoiceVisible] = useState(false);
    const [printOrientationChoice, setPrintOrientationChoice] = useState('landscape');
    const [printLayoutChoice, setPrintLayoutChoice] = useState('branded');
  const [tableSessionKey, setTableSessionKey] = useState(0);
  const ref = useRef(null);
  const tableContainerRef = useRef(null);
  const overlayRef = useRef(null);
  const inFlightRef = useRef({ sig: null, promise: null });
  const completedCacheRef = useRef(new Map());
  const tableBuiltRef = useRef(false);
  const lastResponseRef = useRef(null);
  const isRestoringRef = useRef(false);
  const userInteractedRef = useRef(false);
  const savedHScrollRef = useRef({ left: 0, pending: false });
  const lastContainerHeightRef = useRef(0);
  const needsRedrawRef = useRef(false);
  const pendingRowIdsRef = useRef(new Set());
  const rafRedrawRef = useRef(null);
  const submittedSearchValueRef = useRef('');
  const pendingInvalidationRef = useRef(false);
  const mutationOverlayRef = useRef(new Map());
  const listMountedRef = useRef(true);
  const restartQueuedRef = useRef(false);
  const ajaxGenerationRef = useRef(0);
  const confirmedQueryRef = useRef({ filters: [], sorters: [] });
  const sessionQueryActiveRef = useRef(false);

  const getTable = useCallback(() => ref.current?.table ?? ref.current, []);

  const isTableVisible = useCallback(() => {
    const el = tableContainerRef.current;
    if (el && el.offsetParent != null && el.clientHeight > 0) return true;
    const table = getTable();
    const tel = table?.getElement?.() ?? table?.element;
    return !!(tel && tel.offsetParent != null && tel.clientHeight > 0);
  }, [getTable]);

  const snapshotConfirmedQuery = useCallback(() => {
    const table = getTable();
    confirmedQueryRef.current = {
      filters: coerceHeaderFilterList(table?.getHeaderFilters?.()),
      sorters: cleanSorters(table?.getSorters?.() || []),
    };
  }, [getTable]);

  const restartFullProgressiveSession = useCallback(() => {
    if (!listMountedRef.current || restartQueuedRef.current) return;
    snapshotConfirmedQuery();
    sessionQueryActiveRef.current = true;
    ajaxGenerationRef.current += 1;
    pendingInvalidationRef.current = false;
    mutationOverlayRef.current = new Map();
    restartQueuedRef.current = true;
    completedCacheRef.current.clear();
    lastResponseRef.current = null;
    inFlightRef.current = { sig: null, promise: null };
    tableBuiltRef.current = false;
    isRestoringRef.current = true;
    const table = getTable();
    if (typeof table?.destroy === 'function') table.destroy();
    ref.current = null;
    setTableSessionKey((key) => key + 1);
  }, [getTable, snapshotConfirmedQuery]);

  const requestFullProgressiveSessionRestart = useCallback(() => {
    if (!listMountedRef.current) return;
    if (!isTableVisible()) {
      pendingInvalidationRef.current = true;
      return;
    }
    restartFullProgressiveSession();
  }, [isTableVisible, restartFullProgressiveSession]);

  const getLoadedRowComponent = useCallback((id) => {
    const table = getTable();
    if (!table || typeof table.getRow !== 'function' || id == null || id === '') return null;
    try {
      const row = table.getRow(id);
      return row && row !== false ? row : null;
    } catch (_e) {
      return null;
    }
  }, [getTable]);

  const scheduleRedraw = useCallback(() => {
    if (rafRedrawRef.current != null) return;
    rafRedrawRef.current = requestAnimationFrame(() => {
      const table = getTable();
      rafRedrawRef.current = null;
      if (!table) return;
      const ids = Array.from(pendingRowIdsRef.current);
      pendingRowIdsRef.current.clear();
      needsRedrawRef.current = false;
      ids.forEach((id) => {
        const row = table.getRow?.(id);
        if (!row) return;
        row.reformat?.();
      });
    });
  }, [getTable]);

  const applySafeEmployeePatch = useCallback((detail) => {
    const canonicalRow = detail?.row && typeof detail.row === 'object' && !Array.isArray(detail.row)
      ? (detail.row.data && detail.row.data.id != null ? detail.row.data : detail.row)
      : null;
    const id = detail?.id ?? canonicalRow?.id;
    const rowComponent = getLoadedRowComponent(id);
    if (!rowComponent || typeof rowComponent.update !== 'function' || !canonicalRow) {
      requestFullProgressiveSessionRestart();
      return;
    }
    rowComponent.update(canonicalRow);
    mutationOverlayRef.current.set(String(id), canonicalRow);
    pendingRowIdsRef.current.add(id);
    if (isTableVisible()) scheduleRedraw();
    else needsRedrawRef.current = true;
  }, [getLoadedRowComponent, isTableVisible, requestFullProgressiveSessionRestart, scheduleRedraw]);

  const captureHScroll = useCallback(() => {
    const table = getTable();
    if (!table) return;
    const holder = table.rowManager?.element;
    if (!holder) return;
    savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
  }, [getTable]);

  const restoreHScroll = useCallback(() => {
    if (!savedHScrollRef.current.pending) return;
    const table = getTable();
    if (!table) return;
    const holder = table.rowManager?.element;
    const header = table.columnManager?.contentsElement;
    if (!holder) return;
    const left = savedHScrollRef.current.left;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        holder.scrollLeft = left;
        if (header) header.scrollLeft = left;
        savedHScrollRef.current.pending = false;
      });
    });
  }, [getTable]);

  useEffect(() => {
    listMountedRef.current = true;
    return () => {
      listMountedRef.current = false;
      if (rafRedrawRef.current != null) {
        cancelAnimationFrame(rafRedrawRef.current);
        rafRedrawRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    const el = tableContainerRef.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    const ro = new ResizeObserver(() => {
      const h = el.clientHeight;
      const visible = h > 0 || isTableVisible();
      if (visible) {
        const wasHidden = lastContainerHeightRef.current <= 0;
        lastContainerHeightRef.current = Math.max(h, 1);
        if (pendingInvalidationRef.current) {
          requestAnimationFrame(() => restartFullProgressiveSession());
        } else if (wasHidden) {
          requestAnimationFrame(() => getTable()?.redraw?.(true));
        } else if (needsRedrawRef.current && isTableVisible()) {
          scheduleRedraw();
        }
      } else {
        lastContainerHeightRef.current = 0;
      }
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [getTable, isTableVisible, restartFullProgressiveSession, scheduleRedraw]);

  useEffect(() => {
    const onUpdated = (event) => {
      const decision = classifyTrainingCardListMutation(event, {
        toolbarSearch: submittedSearchValueRef.current,
        activeHeaderFilters: coerceHeaderFilterList(getTable()?.getHeaderFilters?.()),
        activeSorters: cleanSorters(getTable()?.getSorters?.() || []),
        isRowLoaded: (id) => Boolean(getLoadedRowComponent(id)),
      });
      if (decision === SESSION_SAFE_UPDATE) {
        applySafeEmployeePatch(event.detail);
        return;
      }
      requestFullProgressiveSessionRestart();
    };
    const onRemoved = () => {
      requestFullProgressiveSessionRestart();
    };
    window.addEventListener(TRAINING_CARDS_UPDATED_EVENT, onUpdated);
    window.addEventListener(TRAINING_CARDS_REMOVED_EVENT, onRemoved);
    return () => {
      window.removeEventListener(TRAINING_CARDS_UPDATED_EVENT, onUpdated);
      window.removeEventListener(TRAINING_CARDS_REMOVED_EVENT, onRemoved);
    };
  }, [applySafeEmployeePatch, getLoadedRowComponent, getTable, requestFullProgressiveSessionRestart]);

  function searchTable() {
    const normalized = String(searchValue ?? '').trim();
    submittedSearchValueRef.current = normalized;
    setSearchIconColor(normalized === '' ? '' : 'active');
    captureHScroll();
    requestFullProgressiveSessionRestart();
    setVisibleSearch(false);
  }

  const clearSearch = () => {
    setSearchIconColor('');
    setSearchValue('');
    submittedSearchValueRef.current = '';
    captureHScroll();
    requestFullProgressiveSessionRestart();
  };

    const accept = () => {
        let rows_to_delete = [];
        rows_to_delete = getTable()?.getSelectedData?.() ?? [];
        rows_to_delete.forEach(() => {});
    }

    const reject = () => {
        toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
    }

    const confirm = () => {
        confirmDialog({
            message: t('Common.ConfirmDeleteRecord'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.Yes'),
            rejectLabel: t('Common.No'),
            accept,
            reject
        });
    };

  const onSelectRow = (data, rows) => {
    setEditIcon(true);
    setCopyIcon(true);
    setDeleteIcon(true);
    const sel = getTable()?.getSelectedData?.() ?? [];
    if (sel.length > 0) {
      if (sel.length === 1) {
        if(user.permissions?.includes("add training"))setCopyIcon(false);
        if(user.permissions?.includes("edit training"))setEditIcon(false);
      }
      if(user.permissions?.includes("delete training"))setDeleteIcon(false);
    }
  };

  function onEditRow(employee){
    const table = getTable();
    const filters = (table?.getHeaderFilters?.() || []).map(f => ({ field: f.field, value: f.value }));
    const sorters = cleanSorters(table?.getSorters?.() || []);
    const navigationContext = { filters, sorters };
    dispatch({
      type: 'create_new_tab',
      name: t('TrainingCardList.Tab.EditWithName', { name: employee?.name || employee?.employee_name || '' }),
      translationKey: 'TrainingCardList.Tab.EditWithName',
      translationParams: { name: employee?.name || employee?.employee_name || '' },
      legacyLabel: t('TrainingCardList.Text.Upravit_kartu_zamestnanca'),
      page: 'TrainingCardDetail',
      props: { employee, type: 'edit', not_last_used: true, navigationContext },
      mask: 'trng004',
    });
  }

  function EditRowFormatter(props) {
    const rowData = props.cell.getRow().getData();
    return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
  }

  function State(props) {
    const rowData = props.cell.getRow().getData();
    for (const card of rowData.training_card || []) {
      if(card?._children?.length == 0) return "NOK";
      if(card?._children?.length > 0 && !card?.deactivation_date && new Date(card?._children[0]?.next_training_date) < new Date()) return "NOK";
    }
    return "OK";
  }

  function Status(props) {
    const rowData = props.cell.getRow().getData();
    if(rowData?.date_of_departure=="" || rowData?.date_of_departure==null) return t('Common.Active');
    else return t('Common.Inactive');
  }

  function DateOfEntry(props) {
    const rowData = props.cell.getRow().getData();
    if (!rowData.date_of_entry) return "";
    const dt = DateTime.fromISO(String(rowData.date_of_entry));
    return dt.isValid ? dt.toFormat(dateFmt) : "";
  }

  function DateOfDeparture(props) {
    const rowData = props.cell.getRow().getData();
    if (!rowData.date_of_departure) return "";
    const dt = DateTime.fromISO(String(rowData.date_of_departure));
    return dt.isValid ? dt.toFormat(dateFmt) : "";
  }

  function auditDateText(raw) {
    if (raw == null || raw === '') return '';
    if (formatDate) {
      const text = formatDate(raw, dateTimeFmt, true);
      return text || '';
    }
    const dt = DateTime.fromISO(String(raw));
    return dt.isValid ? dt.toFormat(dateTimeFmt) : '';
  }

  function CreatedAtFormatter(props) {
    const rowData = props.cell.getRow().getData();
    const u = rowData?.created_by_user;
    const displayName = u?.employee?.name || u?.username || '';
    const text = auditDateText(rowData?.created_at);
    return (
      <div className="flex items-center justify-start w-full h-full min-w-0 gap-1">
        {u ? (
          <Avatar
            className="shrink-0"
            title={displayName}
            label={getUserInitials?.(displayName) || ''}
            shape="circle"
            style={{ backgroundColor: getUserColor?.(u?.username) || '#6b7280', color: '#ffffff' }}
          />
        ) : null}
        <div className="min-w-0 flex-1 truncate whitespace-nowrap" title={text || undefined}>{text}</div>
      </div>
    );
  }

  function UpdatedAtFormatter(props) {
    const rowData = props.cell.getRow().getData();
    const u = rowData?.last_touched_by_user;
    const displayName = u?.employee?.name || u?.username || '';
    const text = auditDateText(rowData?.updated_at);
    return (
      <div className="flex items-center justify-start w-full h-full min-w-0 gap-1">
        {u ? (
          <Avatar
            className="shrink-0"
            title={displayName}
            label={getUserInitials?.(displayName) || ''}
            shape="circle"
            style={{ backgroundColor: getUserColor?.(u?.username) || '#6b7280', color: '#ffffff' }}
          />
        ) : null}
        <div className="min-w-0 flex-1 truncate whitespace-nowrap" title={text || undefined}>{text}</div>
      </div>
    );
  }

  function stateHeaderFilter(headerValue, rowValue, rowData, filterParams){
    let state = "";
    for (const card of rowData.training_card || []) {
      if(card?._children?.length == 0) state="NOK";
      if(card?._children?.length > 0 && !card?.deactivation_date && new Date(card?._children[0]?.next_training_date) < new Date()) state="NOK";
    }
    if(state=="")state="OK";
    if (!headerValue || String(headerValue).trim() === '') return true;
    const selected = String(headerValue).split(',').map(s => s.trim().toUpperCase()).filter(Boolean);
    return selected.length > 0 && selected.includes(state.toUpperCase());
  }

  function statusHeaderFilter(headerValue, rowValue, rowData, filterParams){
    let state = "";
    if(rowData?.date_of_departure=="" || rowData?.date_of_departure==null)state="Aktívny";
    else state="Neaktívny";
    if (!headerValue || String(headerValue).trim() === '') return true;
    const selected = String(headerValue).split(',').map(s => s.trim().toUpperCase()).filter(Boolean);
    return selected.length > 0 && selected.includes(state.toUpperCase());
  }

  function dateHeaderFilter(headerValue, rowValue, rowData, filterParams){
    if (!headerValue || String(headerValue).trim() === '') return true;
    if(filterParams.name=="date_of_entry"){
        if(!rowData?.date_of_entry)return false;
        const dt = DateTime.fromISO(String(rowData.date_of_entry));
        return dt.isValid && dt.toFormat(dateFmt).includes(headerValue);
    }
    else{
        if(!rowData?.date_of_departure)return false;
        const dt = DateTime.fromISO(String(rowData.date_of_departure));
        return dt.isValid && dt.toFormat(dateFmt).includes(headerValue);
    }
  }

  const normalizeText = (value) => (value ?? "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

  function textHeaderFilter(headerValue, rowValue) {
    if (!headerValue) return true;
    return normalizeText(rowValue).includes(normalizeText(headerValue));
  }

  function dateColumnFilter(headerValue, rowValue, rowData, filterParams) {
    if (!headerValue || String(headerValue).trim() === '') return true;
    if (String(headerValue).startsWith('range:')) return true;
    const search = normalizeText(headerValue);
    const name = filterParams?.name;
    if (name === 'created_at' && rowData?.created_by_user) {
      const userName = rowData.created_by_user?.employee?.name || rowData.created_by_user?.username || '';
      if (normalizeText(userName).includes(search)) return true;
    }
    if (name === 'updated_at') {
      const touched = rowData?.last_touched_by_user;
      if (touched) {
        const userName = touched?.employee?.name || touched?.username || '';
        if (normalizeText(userName).includes(search)) return true;
      }
    }
    const field = name === 'created_at' ? 'created_at' : 'updated_at';
    const raw = rowData?.[field];
    if (!raw) return false;
    const dt = DateTime.fromISO(String(raw));
    const variants = dt.isValid
      ? [dt.toFormat(dateFmt), dt.toFormat(dateTimeFmt), dt.toFormat('yyyy-MM-dd')].join(' ')
      : '';
    return normalizeText(variants).includes(search);
  }

  const departments = state.departments || [];
  const departmentsKey = departments.length ? departments.map(d => d.id).join(',') : '';
  const idTitle = t('EmployeeList.Column.Id');
  const createdTitle = t('EmployeeList.Column.CreatedAt');
  // EmployeeList.Column.UpdatedAt (t('Common.Column.UpdatedAt')) is employees.updated_at — last Employee row change, not nested TrainingCard activity.
  const updatedTitle = t('EmployeeList.Column.UpdatedAt');
  const columns = useMemo(() => [
    { field: 'rowSelection', formatter:"rowSelection", titleFormatter:"rowSelection", hozAlign:"center", width: 44, minWidth: 44, headerSort: false, resizable: false, frozen: true, print: false, download: false },
    { title: '', field: 'editor', hozAlign:"center", width: 44, minWidth: 44, headerSort: false, formatter: reactFormatter(<EditRowFormatter/>), resizable: false, frozen: true, print: false, download: false },
    buildTabulatorIdColumn({ frozen: true, headerFilterFunc: textHeaderFilter, extra: { title: idTitle } }),
    { title: t('EmployeeAdd.Label.Name'), field: 'name', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('EmployeeAdd.Label.Name')), widthGrow: 1},
    { title: t('Common.DefinedId'), field: 'defined_id', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.DefinedId')), widthGrow: 1},
    { title: t('Common.Department'), field: 'department.name', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { options: departments.map(d => ({ label: d.name, value: d.name })), placeholder: t('Common.Department'), minWidth: '180px' }, minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Department'), 'multiselect'), widthGrow: 1 },
    { title: t('Common.Status'), field: 'my_state', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { options: [{ label: 'OK', value: 'OK' }, { label: 'NOK', value: 'NOK' }], placeholder: t('Common.Status'), minWidth: '150px' }, headerFilterFunc: stateHeaderFilter, formatter: reactFormatter(<State/>), minWidth: tabulatorColumnMinWidthFromTitle(t('Common.Status'), 'multiselect'), widthGrow: 1 },
    { title: t('Common.EmployeeStatus'), field: 'my_status', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { options: [{ label: t('Common.Active'), value: 'Aktívny' }, { label: t('Common.Inactive'), value: 'Neaktívny' }], placeholder: t('Common.EmployeeStatus'), minWidth: '180px' }, headerFilterFunc: statusHeaderFilter, formatter: reactFormatter(<Status/>), minWidth: tabulatorColumnMinWidthFromTitle(t('Common.EmployeeStatus'), 'multiselect'), widthGrow: 1 },
    { title: t('EmployeeAdd.Label.DateOfEntry'), field: 'date_of_entry', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, formatter: reactFormatter(<DateOfEntry/>), headerFilterFunc:dateHeaderFilter, headerFilterFuncParams:{name:"date_of_entry"}, minWidth: tabulatorColumnMinWidthFromTitle(t('EmployeeAdd.Label.DateOfEntry')), widthGrow: 1},
    { title: t('EmployeeAdd.Label.DateOfDeparture'), field: 'date_of_departure', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, formatter: reactFormatter(<DateOfDeparture/>), headerFilterFunc:dateHeaderFilter, headerFilterFuncParams:{name:"date_of_departure"}, minWidth: tabulatorColumnMinWidthFromTitle(t('EmployeeAdd.Label.DateOfDeparture')), widthGrow: 1},
    { title: t('EmployeeAdd.Label.Description'), field: 'description', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, headerFilterFunc: textHeaderFilter, minWidth: tabulatorColumnMinWidthFromTitle(t('EmployeeAdd.Label.Description')), widthGrow: 1},
    { title: createdTitle, field: 'created_at', minWidth: tabulatorDateUserColumnMinWidth(createdTitle), formatter: reactFormatter(<CreatedAtFormatter />), headerFilter: dateUserHeaderFilter, headerFilterLiveFilter: false, headerFilterParams: { dateFormat: dateFmt, dateTimeFormat: dateTimeFmt }, headerFilterFunc: dateColumnFilter, headerFilterFuncParams: { name: 'created_at' }, hozAlign: 'left', sorter: 'datetime', sorterParams: { format: 'iso' } },
    { title: updatedTitle, field: 'updated_at', minWidth: tabulatorDateUserColumnMinWidth(updatedTitle), formatter: reactFormatter(<UpdatedAtFormatter />), headerFilter: dateUserHeaderFilter, headerFilterLiveFilter: false, headerFilterParams: { dateFormat: dateFmt, dateTimeFormat: dateTimeFmt }, headerFilterFunc: dateColumnFilter, headerFilterFuncParams: { name: 'updated_at' }, hozAlign: 'left', sorter: 'datetime', sorterParams: { format: 'iso' } },
  ], [departmentsKey, dateFmt, dateTimeFmt, createdTitle, updatedTitle, idTitle]);

  const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
    const extra = { ...extractSafePaginationParams(paramsFromTabulator) };
    if (extra.size == null) extra.size = pageSizePc;
    extra.show_deactivated = showDeactivated ? '1' : '0';
    extra.show_inactive_employees = showInactiveEmployees ? '1' : '0';
    const search = String(submittedSearchValueRef.current ?? '').trim();
    if (search !== '') extra.toolbar_search = search;
    mergePagedStandardListFiltersAndSorters(extra, {
      getTable: tableBuiltRef.current ? getTable : () => null,
      tableBuiltForParams: tableBuiltRef.current,
      userMaskFilters: state.user_mask_filters,
      maskPage: PAGE_LIST_KEY,
      filterKeyStyle: 'literal_field',
    });
    return extra;
  }, [getTable, state.user_mask_filters, pageSizePc, showDeactivated, showInactiveEmployees]);
  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: TRAINING_CARD_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);


  const buildRequestParamsRef = useRef(buildRequestParams);
  buildRequestParamsRef.current = buildRequestParams;
  const getBuildRequestParams = useCallback((paramsFromTabulator) => buildRequestParamsRef.current(paramsFromTabulator), []);

  const getPrintColumnsOrder = useCallback(() => {
    const table = getTable();
    const allowed = Object.keys(DEFAULT_COLUMNS_VISIBLE);
    const fallback = () => allowed.filter((f) => columnsVisible[f] !== false);
    if (!table?.getColumns) return fallback();
    const allowedSet = new Set(allowed);
    const out = [];
    const seen = new Set();
    try {
      table.getColumns().forEach((col) => {
        const field = col.getField?.() ?? col.getDefinition?.()?.field;
        if (!field || !allowedSet.has(field)) return;
        if (columnsVisible[field] === false) return;
        if (seen.has(field)) return;
        seen.add(field);
        out.push(field);
      });
    } catch (_) {
      return fallback();
    }
    return out.length > 0 ? out : fallback();
  }, [getTable, columnsVisible]);

  const buildTrainingCardExportQueryString = useCallback((opts = {}) => {
    const extra = {
      show_deactivated: showDeactivated ? '1' : '0',
      show_inactive_employees: showInactiveEmployees ? '1' : '0',
    };
    const search = String(submittedSearchValueRef.current ?? '').trim();
    if (search !== '') extra.toolbar_search = search;
    mergePagedStandardListFiltersAndSorters(extra, {
      getTable: tableBuiltRef.current ? getTable : () => null,
      tableBuiltForParams: tableBuiltRef.current,
      userMaskFilters: state.user_mask_filters,
      maskPage: PAGE_LIST_KEY,
      filterKeyStyle: 'literal_field',
    });
    return buildExportQueryStringFromParams(extra, opts);
  }, [getTable, showDeactivated, showInactiveEmployees, state.user_mask_filters]);

  const runTrainingCardPrint = useCallback(async () => {
    try {
      setPrintChoiceVisible(false);
      setDialogText?.(t('Common.PreparingPrint'));
      setVisible?.(true);
      const suffix = buildTrainingCardExportQueryString({
        includePrintColumns: true,
        printLayout: printLayoutChoice,
        printOrientation: printOrientationChoice,
        printColumns: getPrintColumnsOrder(),
      });
      const html = await fetchTextGet(`/api/training_cards/export/print${suffix}`);
      if (!openPrintHtmlWindow(html)) {
        toast?.current?.show({ severity: 'warn', summary: t('DepartmentList.Toast.PrintTitle'), detail: t('Common.EnablePopups'), life: 4000 });
      }
    } catch (e) {
      toast?.current?.show({ severity: 'error', summary: t('DepartmentList.Toast.PrintTitle'), detail: e?.message || t('DepartmentList.Toast.PrintFailed'), life: 4500 });
    } finally {
      setVisible?.(false);
    }
  }, [buildTrainingCardExportQueryString, getPrintColumnsOrder, printLayoutChoice, printOrientationChoice, setDialogText, setVisible, t, toast]);

  const exportTrainingCardsXlsx = useCallback(async () => {
    try {
      setDialogText?.(t('Common.PreparingExport'));
      setVisible?.(true);
      const suffix = buildTrainingCardExportQueryString({
        includePrintColumns: true,
        printColumns: getPrintColumnsOrder(),
      });
      const defaultXlsx = xlsxDownloadFilename('training-cards');
      const { blob, filename } = await downloadBlobGet(`/api/training_cards/export/xlsx${suffix}`, defaultXlsx);
      triggerBlobDownload(blob, filename || defaultXlsx);
    } catch (e) {
      toast?.current?.show({ severity: 'error', summary: t('DepartmentList.Toast.ExportTitle'), detail: e?.message || t('DepartmentList.Toast.ExportFailed'), life: 4500 });
    } finally {
      setVisible?.(false);
    }
  }, [buildTrainingCardExportQueryString, getPrintColumnsOrder, setDialogText, setVisible, t, toast]);

  const restoreHeaderFilters = useCallback((table, rawFilters) => {
    const filterEntries = Array.isArray(rawFilters)
      ? rawFilters
      : (rawFilters && typeof rawFilters === 'object'
        ? Object.entries(rawFilters).map(([field, value]) => ({ field, value }))
        : []);
    if (sessionQueryActiveRef.current && filterEntries.length === 0) {
      table.clearHeaderFilter?.();
      return;
    }
    filterEntries.forEach((filter) => {
      if (!filter?.field) return;
      const value = filter.value;
      if (value == null || value === '') return;
      const def = table.getColumn?.(filter.field)?.getDefinition?.();
      if (!def?.headerFilter) return;
      table.setHeaderFilterValue?.(filter.field, value, true);
    });
  }, []);

  const scrollToFirst = () => scrollToFirstUtil(getTable());
  const scrollUp = () => scrollUpUtil(getTable());
  const scrollDown = () => scrollDownUtil(getTable());
  const scrollToLast = () => scrollToLastUtil(getTable());

  function addNewEmployee(){
    dispatch({ type: 'create_new_tab', name: t('TrainingCardList.Text.Nova_karta_zamestnanca'), translationKey: 'TrainingCardList.Text.Nova_karta_zamestnanca', legacyLabel: t('TrainingCardList.Text.Nova_karta_zamestnanca'), page: 'TrainingCardAdd', props: { employee: null, type: 'add' }, mask: 'trng003' });
  }
  function copyEmployee(){
    const table = getTable();
    const sel = table?.getSelectedData?.()?.[0];
    const filters = (table?.getHeaderFilters?.() || []).map(f => ({ field: f.field, value: f.value }));
    const sorters = cleanSorters(table?.getSorters?.() || []);
    const navigationContext = { filters, sorters };
    dispatch({ type: 'create_new_tab', name: t('TrainingCardList.Text.Nova_karta_zamestnanca'), translationKey: 'TrainingCardList.Text.Nova_karta_zamestnanca', legacyLabel: t('TrainingCardList.Text.Nova_karta_zamestnanca'), page: 'TrainingCardAdd', props: { employee: sel, type: 'add', not_last_used: true, navigationContext }, mask: 'trng003' });
  }
  function editEmployee(){
    const table = getTable();
    const sel = table?.getSelectedData?.()?.[0];
    const filters = (table?.getHeaderFilters?.() || []).map(f => ({ field: f.field, value: f.value }));
    const sorters = cleanSorters(table?.getSorters?.() || []);
    const navigationContext = { filters, sorters };
    dispatch({
      type: 'create_new_tab',
      name: t('TrainingCardList.Tab.EditWithName', { name: sel?.name || sel?.employee_name || '' }),
      translationKey: 'TrainingCardList.Tab.EditWithName',
      translationParams: { name: sel?.name || sel?.employee_name || '' },
      legacyLabel: t('TrainingCardList.Text.Upravit_kartu_zamestnanca'),
      page: 'TrainingCardDetail',
      props: { employee: sel, type: 'edit', not_last_used: true, navigationContext },
      mask: 'trng004',
    });
  }

  function setMask(item, value){
    if (!Object.prototype.hasOwnProperty.call(DEFAULT_COLUMNS_VISIBLE, item)) return;
    const next = { ...DEFAULT_COLUMNS_VISIBLE, ...columnsVisible, [item]: value };
    if (!Object.values(next).some(Boolean)) return;
    applyDataColumnVisibilityToTable(getTable(), next);
    setColumnsVisible(next);
  }

  const itemRenderer = (item, options) => (
    <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
        <span className={`${item.icon} text-primary`} />
        <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
        {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
    </a>
  );

  const [expandedKeys, setExpandedKeys] = useState({});

  const handleClickOutside = (event) => {
    if (overlayRef.current && !overlayRef.current.contains(event.target)) {
        setExpandedKeys({});
    }
  };

  useEffect(() => {
      document.addEventListener('click', handleClickOutside, true);
      return () => {
          document.removeEventListener('click', handleClickOutside, true);
      };
  }, []);

  const resetMask = () => resetTabulatorMask({
    page: PAGE_LIST_KEY,
    defaultColumnsVisible: DEFAULT_COLUMNS_VISIBLE,
    ref,
    columns,
    setColumnsVisible,
    onAfterReset: () => requestFullProgressiveSessionRestart(),
  });

    const items = [
    {
      key: '0',
      label: t('Common.Actions'),
      icon: 'pi pi-sliders-v',
      template: itemRenderer,
      items: [
            {
              key: '0_1',
              label: t('Common.SetFilter'),
              icon: 'pi pi-filter',
              command: () => { userInteractedRef.current = true; setUserMaskFilter(PAGE_LIST_KEY, "set_filters", null, getTable()?.getHeaderFilters?.() ?? [], null); requestFullProgressiveSessionRestart(); },
              template: itemRenderer,
          },
            {
              key: '0_2',
              label: t('Common.ClearFilter'),
              icon: 'pi pi-filter-slash',
              command: () => { userInteractedRef.current = true; setUserMaskFilter(PAGE_LIST_KEY, "set_filters", null, [], null); getTable()?.clearHeaderFilter?.(); requestFullProgressiveSessionRestart(); },
              template: itemRenderer,
          },
          {
              key: '0_3',
              label: t('Common.SetSorting'),
              icon: 'pi pi-sort-alt',
              command: () => { userInteractedRef.current = true; setUserMaskFilter(PAGE_LIST_KEY, "set_sorters", null, null, null, cleanSorters(getTable()?.getSorters?.() ?? [])); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); requestFullProgressiveSessionRestart(); },
              template: itemRenderer,
          },
          {
              key: '0_4',
              label: t('Common.ClearSorting'),
              icon: 'pi pi-sort-alt-slash',
              command: () => { userInteractedRef.current = true; setUserMaskFilter(PAGE_LIST_KEY, "set_sorters", null, null, null, []); getTable()?.setSort?.([]); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); requestFullProgressiveSessionRestart(); },
              template: itemRenderer,
          },
          {
              key: '0_5',
              label: t('Common.SetMask'),
              icon: 'pi pi-server',
              command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
              template: itemRenderer,
          },
          { key: '0_5b', label: t('Common.ResetUserMask'), icon: 'pi pi-refresh', command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); }, template: itemRenderer },
          {
            key: '0_6',
            label: t('Common.Notifications'),
            icon: 'pi pi-envelope',
            command: () => {openChosenNotificationPreferences(PAGE_LIST_KEY);OverflowMenuProvider.setVisible(null);},
            template: itemRenderer,
        },
      ]
    }
  ];

  function changeMarkings(value){
    const next = { ...DEFAULT_COLUMNS_VISIBLE };
    Object.keys(next).forEach((k) => { next[k] = value; });
    if (!value) next.id = true;
    applyDataColumnVisibilityToTable(getTable(), next);
    setColumnsVisible(next);
  }
    return(
      <div className="h-full min-h-0 flex flex-col overflow-hidden">
      <div className='w-full h-10 flex flex-row bg-[#333] shrink-0'>
      <IntersectionObserverWrapper>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button className="disabled:opacity-25" disabled={insertIcon} onClick={() => addNewEmployee()}><AddIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editEmployee()}><EditIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="copy"><button className="disabled:opacity-25" disabled={copyIcon} onClick={() => copyEmployee()}><CopyIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" onClick={confirm} disabled={deleteIcon}><DeleteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="print"><button type="button" onClick={() => setPrintChoiceVisible(true)}><PrintIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="search"><button type="button" title={searchIconColor !== 'active' ? t('Common.Search') : t('ServiceTask.CancelSearch')} onClick={searchIconColor !== 'active' ? () => setVisibleSearch(true) : clearSearch}>{searchIconColor === '' ? <MdSearch fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" /> : <MdSearchOff fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" />}</button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="export"><button type="button" onClick={exportTrainingCardsXlsx}><ExportIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={() => { userInteractedRef.current = true; requestFullProgressiveSessionRestart(); }} title={t('Common.Refresh')}><RefreshIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button onClick={() => scrollUp()}><BackIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog("Karty zamestnancov", PAGE_LIST_KEY)}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="fast"><button onClick={() => setFastView(PAGE_LIST_KEY,columnsVisible,columns)}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
          <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
        </div>
        </IntersectionObserverWrapper>
      </div>
      <div className='px-1 bg-white rounded-md shadow-md flex-1 min-h-0 overflow-hidden'>
        <div ref={tableContainerRef} className="flex-1 min-h-0 overflow-hidden">
      <ReactTabulator
      key={tableSessionKey}
      className='h-[calc(100vh_-_193px)]'
      onRef={(r) => (ref.current = r?.current ?? r)}
      columns={columns}
      events={{
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
          isRestoringRef.current = true;
          userInteractedRef.current = false;
          const table = getTable();
          const restartRestore = sessionQueryActiveRef.current;
          if (!table) {
            tableBuiltRef.current = true;
            restartQueuedRef.current = false;
            setTimeout(() => {
              isRestoringRef.current = false;
              sessionQueryActiveRef.current = false;
            }, 0);
            return;
          }
          const effective = getEffectiveMask(PAGE_LIST_KEY, state);
          if (effective?.type === 'user' && effective.userMask) {
            const mask = effective.userMask;
            try {
              table.blockRedraw?.();
              const attributes = sanitizeTabulatorLayoutAttributes(safeParse(mask.attributes, []), TABULATOR_GROUP_A_FLAT_REMOTE_LAYOUT_SANITIZE_OPTIONS);
              if (layoutAttributesIncludeId(attributes) && attributes.length > 1) {
                table.setColumnLayout?.(attributes);
              }
              if (restartRestore) {
                restoreHeaderFilters(table, confirmedQueryRef.current.filters);
              } else {
                restoreHeaderFilters(table, parseMaskFilters(mask.filters));
                const sorters = parseSorters(mask.sorters).map((s) => ({
                  column: s.column ?? s.field,
                  dir: s.dir === 'desc' ? 'desc' : 'asc',
                }));
                if (sorters.length > 0) table.setSort?.(sorters);
              }
              const jsonColumns = safeParse(mask.columns, {});
              if (jsonColumns && typeof jsonColumns === 'object' && !Array.isArray(jsonColumns)) {
                const merged = mergeVisibility(jsonColumns);
                setColumnsVisible(merged);
                applyDataColumnVisibilityToTable(table, merged);
              }
            } finally {
              table.restoreRedraw?.(true);
            }
          } else if (effective?.type === 'standard' && effective.standardMask) {
            try {
              table.blockRedraw?.();
              const attributes = sanitizeTabulatorLayoutAttributes(safeParse(effective.standardMask.attributes, []), TABULATOR_GROUP_A_FLAT_REMOTE_LAYOUT_SANITIZE_OPTIONS);
              const jsonColumns = safeParse(effective.standardMask.columns, {});
              if (layoutAttributesIncludeId(attributes) && attributes.length > 1) {
                try { table.setColumnLayout?.(attributes); } catch (_) {}
              }
              if (jsonColumns && typeof jsonColumns === 'object') {
                const merged = mergeVisibility(jsonColumns);
                setColumnsVisible(merged);
                applyDataColumnVisibilityToTable(table, merged);
              }
              if (restartRestore) restoreHeaderFilters(table, confirmedQueryRef.current.filters);
            } finally {
              table.restoreRedraw?.(true);
            }
          } else {
            applyDataColumnVisibilityToTable(table, DEFAULT_COLUMNS_VISIBLE);
            if (restartRestore) restoreHeaderFilters(table, confirmedQueryRef.current.filters);
          }
          tableBuiltRef.current = true;
          restartQueuedRef.current = false;
          setTimeout(() => {
            isRestoringRef.current = false;
            sessionQueryActiveRef.current = false;
          }, 0);
        },
        headerFilterChanged: () => {
          if (isRestoringRef.current) return;
          userInteractedRef.current = true;
          requestFullProgressiveSessionRestart();
        },
        sortChanged: () => {
          if (!isRestoringRef.current) userInteractedRef.current = true;
        },
        dataSorted: () => {
          if (!isRestoringRef.current) userInteractedRef.current = true;
        },
        columnMoved: () => {
          if (!userInteractedRef.current || isRestoringRef.current) return;
          setUserMaskFilter(PAGE_LIST_KEY, "column_move", null, null, getTable()?.getColumnLayout?.());
        },
        columnResized: () => {
          if (!userInteractedRef.current || isRestoringRef.current) return;
          setUserMaskFilter(PAGE_LIST_KEY, "column_resized", null, null, getTable()?.getColumnLayout?.());
        },
        renderComplete: () => restoreHScroll(),
      }}
      options={{
        index: "id",
        renderHorizontal: "virtual",
        layout: "fitColumns",
        autoResize: true,
        rowHeight: TABULATOR_AUDIT_MIN_ROW_HEIGHT,
        movableColumns: true,
        headerSortTristate: true,
        ...(cleanSorters(confirmedQueryRef.current.sorters || []).length > 0
          ? {
            initialSort: cleanSorters(confirmedQueryRef.current.sorters).map((sorter) => ({
              column: sorter.field,
              dir: sorter.dir,
            })),
          }
          : {}),
        ajaxURL: "/api/training_cards/paged",
        ajaxParams: () => ({}),
        ajaxRequestFunc: (url, config, params) => {
          const generation = ajaxGenerationRef.current;
          return createDedupedAjaxRequest(getBuildRequestParams, tabulatorGet, inFlightRef, completedCacheRef, isRestoringRef, lastResponseRef)(url, config, params).then((data) => {
            if (generation !== ajaxGenerationRef.current) {
              return { data: [], last_page: data?.last_page ?? 1, total: 0, current_page: Number(params?.page) || 1 };
            }
            return data;
          });
        },
        dataLoader: true,
        dataLoaderLoading: t('Common.LoadingData'),
        dataLoaderError: t('Common.LoadFailed'),
        placeholder: t('Common.NoData'),
        height: "calc(100vh - 193px)",
        progressiveLoad: "scroll",
        progressiveLoadScrollMargin: 80,
        progressiveLoadDelay: 200,
        paginationSize: pageSizePc,
        filterMode: "remote",
        sortMode: "remote",
        pagination: false,
        ajaxRequesting: () => {
          if (tableBuiltRef.current && !isRestoringRef.current) captureHScroll();
          const table = getTable();
          if (table?.initialized) table.alert?.(t('Common.LoadingData'));
          return true;
        },
        ajaxResponse: (url, params, response) => {
          getTable()?.clearAlert?.();
          const next = applyPagedMutationOverlay(response, mutationOverlayRef.current);
          if (next && typeof next === 'object') lastResponseRef.current = next;
          return next;
        },
        ajaxError: () => {
          getTable()?.clearAlert?.();
        },
        scrollToColumnIfVisible: false,
      }}/>
        </div>
      </div>
<Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
            <div className="flex flex-columns">
              <input
                  value={searchValue} onChange={e => setSearchValue(e.target.value)}
                  type="text"
                  className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
              />
              <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
            </div>
          </Dialog>
          <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){
          if(!item?.field || !Object.prototype.hasOwnProperty.call(DEFAULT_COLUMNS_VISIBLE, item.field)) return null;
                    return <div
                        key={item.field ?? index}
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    >
                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                    </div>
                })}
            <button onClick={() => {setUserMaskFilter(PAGE_LIST_KEY,"set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>
      <PrintOptionsDialog
        visible={printChoiceVisible}
        onHide={() => setPrintChoiceVisible(false)}
        orientation={printOrientationChoice}
        onOrientationChange={setPrintOrientationChoice}
        layout={printLayoutChoice}
        onLayoutChange={setPrintLayoutChoice}
        onConfirm={runTrainingCardPrint}
      />
      </div>
    )

}
